<template>
  <div>
    <ItemTable
      ref="itemTable"
      :disabled="disabled"
      :productionEndDate="productionEndDate"
      :productionDate="productionDate"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import ItemTable from './item-table'
export default {
  mixins: [EditLoading],
  components: { ItemTable },
  props: {
    disabled: { type: Boolean, default: false },
    productionCessationDate: { type: String, default: '' },
    productionEndDate: { type: String, default: '' },
    productionDate: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        productionCessationDate: [],
      },
    }
  },
  computed: {},
  mounted() {
    this.formData.productionCessationDate = JSON.parse(
      this.productionCessationDate || '[]'
    )
    this.$refs.itemTable.loadData(this.formData.productionCessationDate)
  },
  methods: {
    async save() {
      const res = await this.$refs.itemTable.validate()
      if (!res) {
        return
      }
      let listItem = this.$refs.itemTable.getTableData() || []
      listItem = listItem.map((e) => {
        return { cessationDate: e.cessationDate }
      })
      this.$emit('confirm', listItem)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
  margin-bottom: 5px;
}
</style>
